/* eslint-disable */

import React, {Fragment} from 'react';
import getOpeningsPageTitle from '../../../../common/views/helpers/getOpeningsPageTitle';
import FilterAndSearch from './FilterAndSearch';
import OpeningsList from './OpeningsList';
import DepartmentVideos from './DepartmentVideos';
import LocationContent from './LocationContent';
import OpeningsNav from './OpeningsNav';
import PerksList from 'ui/PerksList/PerksList';
// import {useWaypoints} from 'ui/Navbar/useWaypoints';
// import Navbar from 'ui/Navbar/Navbar';
import Banner from 'ui/Banner/Banner';
import Social from 'ui/Social/Social';
import TeamSpotlights from 'ui/Spotlights/Spotlights';
import Raw from 'ui/Raw/Raw';
import {reach} from 'hoek';
import './OpeningsPage.less';

import {addJobOrg} from '../../../../common/utils/getJobsByCategory';
import {flow, uniqBy, map, filter} from 'lodash/fp';

class OpeningsPage extends React.Component {
    state = {
        filters: {
            category: '',
            location: '',
            search: '',
        },
    };

    componentDidMount() {
        this.setFilters();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setFilters();
        }
    }

    setFilters = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = {
            category: urlParams.get('category'),
            location: urlParams.get('location'),
            search: urlParams.get('search'),
        };

        this.setState({filters});
    };

    handleSelect = (ev, item) => {
        let filters = this.state.filters;
        filters[item] = ev.target.value;

        const searchValue = Object.keys(filters)
            .filter((k) => !!filters[k])
            .map((k) => `${k}=${this.state.filters[k]}`)
            .join('&');

        this.props.history.push(
            `/careers/openings${searchValue ? `?${searchValue}` : ''}`,
        );
    };

    handleClear = (ev) => {
        ev.preventDefault();
        window.location.href = '/careers/openings';
    };

    filterTeams() {
        const teams = reach(this.props, 'data.content.sections.0.teams');
        const {category} = this.state.filters;
        if (teams && teams.length) {
            return teams.filter(
                (team) => !category || team.teamId === category,
            );
        }
        return [];
    }

    filterSections(id) {
        const sections = reach(this.props, 'data.content.sections');
        return sections.filter(({type}) => type === id)[0];
    }

    /**
     * Gets all unique categories from workday, formats them to match what front end expects
     * @returns (Object[])
     * @example <caption>Example return value</caption>
     * [{ "label": "Information Technology","value": "information-technology" }]
     */
    makeCategoryFilters(requisitions, location = null, teams = []) {
        let jobs = addJobOrg(requisitions, teams);
        if (location) {
            jobs = this.filterByLocation(jobs, location);
        }

        return flow(
            uniqBy('org'),
            map((req) => {
                return {
                    label:
                        (teams.find((team) => team.teamId === req.org) &&
                            teams.find((team) => team.teamId === req.org)
                                .title) ||
                        req.org,
                    value: req.org,
                };
            }),
        )(jobs);
    }

    /**
     * Gets all unique locations from workday, formats them to match what front end expects
     * @returns (Object[])
     * @example <caption>Example return value</caption>
     * [{ "label": "Rio de Janeiro", "value": "rio-de-janeiro" }]
     */
    makeLocationFilters(requisitions, category = null) {
        if (category) {
            requisitions = this.filterByCategory(requisitions, category);
        }

        return flow(
            uniqBy('Location_City'),
            map((req) => {
                const location = req.Location_City || req.Location_State;
                return {
                    label: location,
                    value: location.split(' ').join('-'),
                };
            }),
        )(requisitions);
    }

    filterByCategory(requisitions, category) {
        return filter((req) => {
            return req.org === category;
        })(requisitions);
    }

    filterByLocation(requisitions, location) {
        const formattedLocation = location.split('-').join(' ');
        return filter((req) => {
            if (req.Location_City) {
                return req.Location_City === formattedLocation;
            }

            return req.Location_State === formattedLocation;
        })(requisitions);
    }

    render() {
        const {
            history,
            data: {content, fullLocale, translations, algolia},
        } = this.props;
        const {sections, continents, requisitions} = content;
        const section = sections[0];
        const unfilteredTeams = section.teams;

        const {
            filters,
            filters: {location, category},
        } = this.state;
        const categoryFilters = this.makeCategoryFilters(
            requisitions,
            location,
            unfilteredTeams,
        );
        const locationFilters = this.makeLocationFilters(
            requisitions,
            category,
        );

        const {query = {}} = this.props.location;
        const msgopts = {
            data: {root: {fullLocale, translations}},
            hash: {},
        }; // TODO: figure out what to do here

        const title = getOpeningsPageTitle(
            query,
            categoryFilters,
            locationFilters,
            msgopts,
        );

        const teams = this.filterTeams();
        const perks = this.filterSections('careersPerksBlock');
        const social = this.filterSections('careersSocial');

        const notFound = translations['careers.openings.no.openings.search'];
        const noOpenings = translations['careers.openings.no.openings'];

        return (
            <div className="container-openings">
                <OpeningsNav />
                <Banner
                    image="//csvcus.homeaway.com/rsrcs/stab-cms-resources/0.6.0/images/careers/career-joblisting.jpg"
                    styleInner={{backgroundSize: 'contain'}}
                >
                    <div className="text-constrained">
                        <h1 className="text-white">{title}</h1>
                        <Raw content={sections[0].body} />
                        <FilterAndSearch
                            categoryFilters={categoryFilters}
                            locationFilters={locationFilters}
                            handleSelect={this.handleSelect}
                            handleClear={this.handleClear}
                            algolia={algolia}
                            history={history}
                            filters={filters}
                        />
                    </div>
                </Banner>
                <div className="container container--overlap">
                    {category && teams.length ? (
                        <Fragment>
                            <main className="col-sm-12 col-md-9">
                                <DepartmentVideos {...teams[0].department} />
                                <TeamSpotlights
                                    spotlights={teams[0].spotlightBlock}
                                    title={translations[
                                        'careers.openings.team.spotlight'
                                    ].replace('{CATEGORY}', teams[0].title)}
                                />
                                <section>
                                    <h2 className="perks-title">
                                        {perks.title}
                                    </h2>
                                    <PerksList {...perks} />
                                </section>
                            </main>
                            <aside className="col-sm-12 col-md-3 container-openings">
                                <OpeningsList
                                    team={teams[0]}
                                    filters={filters}
                                />
                            </aside>
                        </Fragment>
                    ) : (
                        <div
                            className="openings-columns"
                            data-filters-search={filters.search}
                        >
                            {teams.length ? (
                                teams.map((team) => (
                                    <OpeningsList
                                        key={team.teamId}
                                        team={team}
                                        filters={filters}
                                    />
                                ))
                            ) : query.search ? (
                                <h3 className="no-openings text-center">
                                    {`${notFound}: ${query.search}`}
                                </h3>
                            ) : (
                                <h3 className="no-openings text-center">
                                    {noOpenings}
                                </h3>
                            )}
                        </div>
                    )}
                </div>

                {location && (
                    <LocationContent
                        location={location}
                        continents={continents}
                    />
                )}
                <Social {...social} />
            </div>
        );
    }
}

export default OpeningsPage;
